/**
 * @fileoverview Match3 Game Module
 * @description Exports for the Match3 puzzle game
 */

// Types
export * from "./types";

// Hooks
export { useMatch3, default as useMatch3Default } from "./hooks/useMatch3";
export { useMatch3Sounds, default as useMatch3SoundsDefault } from "./hooks/useMatch3Sounds";

// Components
export { Match3Tile } from "./components/Match3Tile";
export { Match3Grid } from "./components/Match3Grid";
export { Match3Header } from "./components/Match3Header";
export { Match3ResultOverlay } from "./components/Match3ResultOverlay";
export { Match3Leaderboard } from "./components/Match3Leaderboard";

